// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"488":"003b2642","945":"e9594741"}[chunkId] + ".css";
};